module.exports = __webpack_public_path__ + "static/Advantage04@1x.86eccdbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/events/new/Advantage04@1x.png
// module id = 692
// module chunks = 216210090109534